import ConditionalRender from 'components/atoms/conditional-render/ConditionalRender'
import Icon from 'components/atoms/icon/Icon'
import Step1EmployeeInfo from 'components/organisms/employees-management/add-new-employee/add-new-employee-steps/Step1EmployeeInfo'
import Step2ChooseRole from 'components/organisms/employees-management/add-new-employee/add-new-employee-steps/Step2ChooseRole'
import Step2CreateRole from 'components/organisms/employees-management/add-new-employee/add-new-employee-steps/Step2CreateRole'
import Step3ChooseSalary from 'components/organisms/employees-management/add-new-employee/add-new-employee-steps/Step3ChooseSalary'
import Step4AddExpenses from 'components/organisms/employees-management/add-new-employee/add-new-employee-steps/Step4AddExpenses'
import Step5AdditionalCompensation from 'components/organisms/employees-management/add-new-employee/add-new-employee-steps/Step5AdditionalCompensation'
import Step6AddGoals from 'components/organisms/employees-management/add-new-employee/add-new-employee-steps/Step6AddGoals'
import Step7AddBonuses from 'components/organisms/employees-management/add-new-employee/add-new-employee-steps/Step7AddBonuses'
import StepsCounter from 'components/organisms/employees-management/add-new-employee/steps-counter/StepsCounter'
import { IconType } from 'lib/helpers/constants/iconTypes'
import withModal from 'lib/helpers/hoc/withModal'
import { usePermissions } from 'lib/hooks/shared/usePermissions'
import React, { FC, useMemo, useState } from 'react'


export interface IUpdateEmployeeProps {
    onConfirm: () => void;
    currentStep: number;
    setCurrentStep: (step: number) => void;
    data: any
}

const UpdateEmployeeProfile: FC<IUpdateEmployeeProps> = ({ onConfirm, currentStep, setCurrentStep, data }) => {

    const parsedGoals = useMemo(() => {
        if (!data?.goals) return [];
        return data.goals.map((goal: any) => ({
            ...goal,
            ...JSON.parse(goal.data) // this spreads the parsed data into the main object
        }));
    }, [data?.goals]);

    const isUpdating = useMemo(() => {
        return data?.isUpdating
    }, [data?.isUpdating])

    const [AllData, setAllData] = useState({
        ...data,
        ...data.user_information,
        ...data?.salary_relation,
        bonuses: data?.bonusess || [],
        permission: [],
        goals: parsedGoals,
        id: data?.user_id,
    });

    const hasPermissionToViewAllEmployees = usePermissions(['employee_management_view'])

    return (
        <>
            <ConditionalRender condition={currentStep !== 1}>
                <button
                    type="button"
                    className="absolute top-[26px] sm:top-[31px] md:top-[45px]"
                    onClick={() => {
                        setCurrentStep(currentStep === 8 ? 2 : currentStep - 1);
                    }}
                >
                    <Icon
                        iconType={IconType.BACK_BUTTON_MODAL}
                        color={'var(--theme)'}
                    />
                </button>
            </ConditionalRender>
            
            <ConditionalRender condition={currentStep !== 8 && hasPermissionToViewAllEmployees}>
                <StepsCounter currentStep={currentStep} />
            </ConditionalRender>

            {{
                1: <Step1EmployeeInfo setCurrentStep={setCurrentStep} setAllData={setAllData} AllData={AllData} isUpdating={isUpdating} onConfirm={onConfirm} />,
                2: <Step2ChooseRole setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} isUpdating={isUpdating} />,
                3: <Step3ChooseSalary setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} isUpdating={isUpdating} />,
                4: <Step4AddExpenses setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} isUpdating={isUpdating} />,
                5: <Step5AdditionalCompensation setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} isUpdating={isUpdating} />,
                6: <Step6AddGoals setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} isUpdating={isUpdating} />,
                7: <Step7AddBonuses AllData={AllData} setAllData={setAllData} onConfirm={onConfirm} isUpdating={isUpdating} />,
                8: <Step2CreateRole setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} onConfirm={onConfirm} />,
            }[currentStep]}
        </>
    )
}

export default withModal(UpdateEmployeeProfile)